import { MinimizedChat } from "../../../types/chat";
import { SpaceChatItem } from "./SpaceChatItem";
import { Add01Icon } from "hugeicons-react";
import "../../../Styles/Skeleton.css";

interface ChatsSectionProps {
  currentSpaceChats: MinimizedChat[];
  isSpaceChatsLoading: boolean;
}

const ChatItemSkeleton = () => (
  <div className="space-chat-item-skeleton">
    <div className="skeleton-title"></div>
    <div className="skeleton-text"></div>
  </div>
);

export const ChatsSection: React.FC<ChatsSectionProps> = ({ currentSpaceChats, isSpaceChatsLoading }) => {
  if (isSpaceChatsLoading) {
    return (
      <div className="space-chats-grid">
        {Array.from({ length: 3 }).map((_, index) => (
          <ChatItemSkeleton key={index} />
        ))}
      </div>
    );
  }

  return (
    <div className="space-chats-grid">
      {currentSpaceChats.length > 0 ? (
        currentSpaceChats.map((chat) => (
          <SpaceChatItem key={chat.id} chat={chat} />
        ))
      ) : (
        <div className="empty-files-state">
          <div className="empty-state-icon">
            <Add01Icon size={32} />
          </div>
          <h3>No conversations yet</h3>
          <p>Click "New Chat" to start a new discussion with your study materials</p>
        </div>
      )}
    </div>
  );
};